import { createSlice } from "@reduxjs/toolkit";

export const referentesSlices = createSlice({
  name: "referentes",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = referentesSlices.actions;

export default referentesSlices.reducer;
